export default __webpack_public_path__ + "/assets/card_01-hover.png";